export var ProductType;
(function (ProductType) {
    ProductType["Physical"] = "Physical";
    ProductType["Digital"] = "Digital";
})(ProductType || (ProductType = {}));
